import React from 'react'
import {ModalProvider, shimmerSeaDarkTheme, staff} from '@pancakeswap/uikit'
import {HelmetProvider} from 'react-helmet-async'
import {Provider} from 'react-redux'
import {ThemeProvider} from 'styled-components'
import {LanguageProvider} from './contexts/Localization'
import {RefreshContextProvider} from './contexts/RefreshContext'
import {ToastsProvider} from './contexts/ToastsContext'
import store from './state'
import {WagmiConfig} from "wagmi";
import {chains, wagmiConfig} from "~/utils/wagmi";
import '@rainbow-me/rainbowkit/styles.css';
import {DisclaimerComponent, RainbowKitProvider} from "@rainbow-me/rainbowkit";

const ThemeProviderWrapper = (props: any) => {
  return <ThemeProvider theme={staff} {...props} />
}

type Props = {
  children?: React.ReactNode
};

const Disclaimer: DisclaimerComponent = ({Text, Link}) => (
  <Text>
    By connecting your wallet, you agree to the{' '}
    <Link href="https://shimmersea.finance/terms">Terms of Service</Link> and
    acknowledge you have read and understand the protocol{' '}
    <Link href="https://disclaimer.xyz">Disclaimer</Link>
  </Text>
);

const Providers: React.FC<Props> = ({children}) => {
  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider
        appInfo={{
          appName: 'TangleSea Staff Frontend',
          disclaimer: Disclaimer
        }}
        chains={chains}
      >
        <Provider store={store}>
          <ToastsProvider>
            <HelmetProvider>
              <ThemeProviderWrapper>
                <LanguageProvider>
                  <RefreshContextProvider>
                    <ModalProvider>{children}</ModalProvider>
                  </RefreshContextProvider>
                </LanguageProvider>
              </ThemeProviderWrapper>
            </HelmetProvider>
          </ToastsProvider>
        </Provider>
      </RainbowKitProvider>
    </WagmiConfig>
  )
}

export default Providers
